// extracted by mini-css-extract-plugin
export default {"root":"TagStatus_root__yk77q","state":"TagStatus_state__d1hF5","doing":"TagStatus_doing__jCcWB","done":"TagStatus_done__tJAjC"};